import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconAdmin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 4.99402C12 5.4668 11.6171 5.85052 11.1453 5.85052C11.1368 5.85052 11.1299 5.85052 11.1214 5.84883L10.2857 9.04195H1.71431L0.818812 6.0938C0.364125 6.07505 0 5.69986 0 5.23898C0 4.7662 0.382875 4.38248 0.854719 4.38248C1.32647 4.38248 1.70944 4.7662 1.70944 5.23898C1.70914 5.3345 1.69357 5.42935 1.66331 5.51995L3.73341 6.73111L5.48381 3.50883C5.36112 3.43192 5.26002 3.32506 5.19004 3.19829C5.12005 3.07153 5.08349 2.92903 5.08378 2.78423C5.08378 2.31145 5.46666 1.92773 5.9385 1.92773C6.41034 1.92773 6.79322 2.31145 6.79322 2.78423C6.79351 2.92903 6.75695 3.07153 6.68696 3.19829C6.61698 3.32506 6.51588 3.43192 6.39319 3.50883L8.14359 6.73111L10.3983 5.41205C10.3274 5.28414 10.2903 5.14026 10.2906 4.99402C10.2906 4.51945 10.6734 4.13752 11.1453 4.13752C11.6171 4.13752 12 4.51955 12 4.99402ZM10.2857 9.3848H1.71431V10.0705H10.2858L10.2857 9.3848Z",
		fill: "#026BB6"
	})
});
export default SvgIconAdmin;
